import { render, staticRenderFns } from "./WebsiteValuation.vue?vue&type=template&id=6fecea98&scoped=true"
import script from "./WebsiteValuation.vue?vue&type=script&lang=js"
export * from "./WebsiteValuation.vue?vue&type=script&lang=js"
import style0 from "./WebsiteValuation.vue?vue&type=style&index=0&id=6fecea98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecea98",
  null
  
)

export default component.exports